import { Component } from 'react';
import Menu from "../Menu";

class MenuFR extends Component {
  render() {

    return (
      
        <Menu 
          language="/fr"
          switches={[
              { url: this.props.switchUrlNL, name: "NL" },
              { url: this.props.switchUrlEN, name: "EN" }
          ]}
          menus={[
              { url:"/fr", name:"Accueil" },
              { url:"#", name:"Notre équipe", 
                  children:[
                    { name:"Frank Coel", url: "/fr/frank-coel"},
                    { name:"Anna Mamchenkova", url: "/fr/anna-mamchenkova"},
                  ] 
              },
              { url:"#", name:"Nos services", 
                  children:[
                    { name:"Redressement d’entreprises", url: "/fr/entreprises-en-difficultes"},
                    { name:"Conseils, défense et litiges", url: "/fr/conseils-defense-litiges"},
                  ] 
              },
              { url:"/fr/presse", name:"Presse" },
              { url:"/fr/contact", name:"Contact" },
          ]}
        />
        
    );
  }
}

export default MenuFR
